<template>
  <div
    :class="{'f-list-wrapper': true, 'f-list-wrapper-plain px-0 py-0': isPlain}">
    <div
      v-if="bulkActions.length && selectedItemsCount > 0"
      class="f-list-bulk-actions">
      <f-button
        v-for="(action, actionIndex) in bulkActions"
        :key="actionIndex"
        :theme="action.theme"
        class=""
        @click.prevent="action.callbackFunction(selectedItems)">
        {{ action.label }} ({{ selectedItemsCount }})
      </f-button>
    </div>
    <table
      :class="{
        'f-list grid mt-0 mb-0 full-width py-2-md': true,
        'bulk-actions-visible': bulkActions.length && selectedItemsCount > 0
      }">
      <thead class="f-list-head bg-light contents">
        <tr class="f-list-row contents">
          <th
            v-for="(heading, headingIndex) in listSettings"
            :key="headingIndex"
            scope="col"
            :class="{
              'f-list-cell': true,
              'align-middle': true,
              'text-left': true,
              'is-sortable': heading.sortable,
              'f-list-cell-actions': heading.type === 'actions',
              'static': !isThSticky
            }">

            <template v-if="itemsSelectable && headingIndex === 0">
              <f-checkbox
                v-if="itemsSelectable && headingIndex === 0"
                v-model="isAllItemsSelected"
                :key="headingIndex"
                :disabled="listItems.length === 0"
                @change="selectAllItems(isAllItemsSelected)">
                {{ heading.title }}
              </f-checkbox>
            </template>
            <template v-else>
              {{ heading.title }}
            </template>

            <f-button
              v-if="listItems.length > 0 && heading.sortable"
              theme="sort-arrow"
              withArrow
              @click.prevent="
                $bus.$emit(
                  heading.sortingEvent,
                  { columnName: heading.variableName })">
            </f-button>

          </th>
        </tr>
      </thead>
      <tbody
        v-if="loaded"
        class="f-list-body contents">
        <tr
          v-for="(item, rowIndex) in listItems"
          :key="rowIndex"
          :class="{
            'f-list-row contents': true,
            'row-highlited': item.itemHighlited,
            'row-dimmed': item.itemDimmed,
            'is-clickable': item.disabled !== true
          }">
          <td
            v-for="(setting, settingsIndex) in listSettings"
            :key="settingsIndex"
            :class="getBodyCellClassList(setting, settingsIndex, item)"
            @click="getIsCellClickable(setting, settingsIndex, item) ? clickCellCalback($event, item) : {}">
            <label
              v-if="setting.type !== 'actions' && setting.type !== 'f-message-counter'"
              class="f-list-mobile-label">
              <template v-if="setting.mobileTitle">
                {{ setting.mobileTitle }}
              </template>
              <template v-else>
                {{ setting.title }}
              </template>
            </label>

            <template v-if="itemsSelectable && settingsIndex === 0">

              <f-checkbox
                :key="settingsIndex"
                class="hidden-mobile-large"
                v-model="selectedItems[item.id]"
                @change="toggleSelect()">
                {{ item[setting.variableName] }}
              </f-checkbox>
              <div class="value-on-mobile hidden-from-desktop-small-only">
                {{ item[setting.variableName] }}
              </div>

            </template>
            <template v-else-if="setting.type === 'f-progress-bar'">

              <f-progress-bar
                :progress="Number(item[setting.variableName])"/>

            </template>
            <template v-else-if="setting.type === 'f-badge'">
              <template v-if="setting.route && item.inquiry_id && !item[setting.variableName].disabled">
                <router-link
                  :to="formatRoute(setting.route, item.inquiry_id)"
                  class="lnk">
                   <f-badge
                    :theme="item[setting.variableName].status"
                    :counter="item[setting.variableName].counter">
                    {{ item[setting.variableName].text }}
                  </f-badge>
                </router-link>
              </template>
              <template v-else>
                <VDropdown
                  v-if="setting.hasTooltip"
                  :ref="`${rowIndex}-${settingsIndex}`">
                  <f-badge
                    class="relative"
                    style="cursor: pointer"
                    :theme="item[setting.variableName].status"
                    :counter="item[setting.variableName].counter"
                    :disabled="item[setting.variableName].disabled"
                    :title="item[setting.variableName].title">
                    {{ item[setting.variableName].text }}
                  </f-badge>
                  <template #popper>
                    <img
                      :src="setting.tooltipImage"
                      :alt="setting.tooltipImageAlt">
                  </template>
                </VDropdown>
                 <f-badge
                  v-else
                  class="relative"
                  :theme="item[setting.variableName].status"
                  :counter="item[setting.variableName].counter"
                  :disabled="item[setting.variableName].disabled"
                  :title="item[setting.variableName].title">
                  {{ item[setting.variableName].text }}
                </f-badge>
              </template>

            </template>
            <template v-else-if="setting.type === 'inquiry-status-select'">

              <status-select
                :inquiryID="item.id"
                :status="item.status"/>

            </template>
            <template v-else-if="setting.type === 'f-time-elapsed'">

              <f-time-elapsed
                :time="item[setting.variableName]"
                :maxTime="setting.maxTime"/>

            </template>
            <template v-else-if="setting.type === 'text-with-counter'">

              <span class="text-with-counter">
                {{ item[setting.variableName].text }}
              </span>
              <span
                v-if="item[setting.variableName].counter && !item[setting.variableName].read"
                class="counter">
                {{ item[setting.variableName].counter }}
              </span>
            </template>

            <template v-else-if="setting.type === 'f-message-counter' && item[setting.variableName] !== null">
              <template v-if="setting.route && !item[setting.variableName].disabled">
                <router-link
                  :to="formatRoute(setting.route, item.id)"
                  class="lnk">
                  <f-message-counter
                    :item="item[setting.variableName]"
                    class="mr-1"/>
                </router-link>
              </template>
              <template v-else>
                <f-message-counter
                  :item="item[setting.variableName]"
                  class="mr-1"/>
              </template>

            </template>
            <template v-else-if="setting.type === 'external-link'">

              <template v-if="item[setting.variableName].url">
                <a
                  :title="item[setting.variableName].text"
                  :href="item[setting.variableName].url"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  :class="'text-medium-light ' + (setting.linkClass) || ''">
                  <f-icon
                    v-if="setting.icon"
                    :name="setting.icon"
                    class="icon" />
                  {{ item[setting.variableName].text }}
                </a>
              </template>
              <template v-else>
                <span>{{ $t('ui.none').toLowerCase() }}</span>
              </template>

            </template>
            <template v-else-if="setting.type === 'actions'">

              <f-dropdown
                :id="'actions-' + rowIndex"
                v-if="getActions(setting.items, item).length"
                theme="minimal"
                type="more"
                :items="getActions(setting.items, item)" />

            </template>
            <template v-else>
              <div>
                <span
                  v-for="(variable, variableIndex) in setting.variableName"
                  :key="variableIndex">
                  <template v-if="item[variable]">
                    {{ item[variable] }}
                  </template>
                  <template v-else>
                    {{ getEmptyValue(setting) }}
                  </template>
                </span>
              </div>

            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="loaded && listItems.length === 0"
      class="f-list-no-results align-middle text-center text-bold pt-4 mt-1-md mt-3-sm">
      {{ $t('advisersFinder.noItemForShow') }}&hellip;
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import StatusSelect from '@/views/forms/inquiry/InquiryStatusSelect.vue';

export default {
  name: 'f-list',
  components: {
    'status-select': StatusSelect
  },
  props: {
    itemsSelectable: {
      type: Boolean,
      default: false,
      required: false
    },
    loaded: {
      type: Boolean,
      default: false
    },
    listItems: {
      type: Array,
      required: true,
    },
    listSettings: {
      type: Array,
      required: true,
    },
    selectionEvent: {
      type: String,
      default: null,
      required: false
    },
    bulkActions: {
      type: Array,
      default: () => []
    },
    itemRoute: {
      type: String
    },
    itemAction: {
      type: Function
    },
    isPlain: {
      type: Boolean,
      default: false
    },
    isThSticky: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    selectedItemsCount () {
      return Object.values(this.selectedItems).reduce((count, item) => count + item, 0);
    }
  },
  data() {
    return {
      isAllItemsSelected: false,
      defaultEmptyValue: this.$t('ui.none').toLowerCase(),
      selectedItems: {},
    }
  },
  mounted () {
    if (this.itemsSelectable) {
      this.createInitialSelectableItemsObject();
    }
  },
  methods: {
    getEmptyValue (setting) {
      if (setting.emptyValue) {
        return setting.emptyValue;
      }

      return this.defaultEmptyValue;
    },
    getActions (actions, params) {
      if (params.actionsList && params.actionsList.length) {
        let actionsCopy = JSON.parse(JSON.stringify(actions));
        actionsCopy = actionsCopy.filter(item => params.actionsList.indexOf(item.name) > -1);

        for (let i = 0; i < actionsCopy.length; i++) {
          actionsCopy[i].param = params;
        }

        return actionsCopy;
      }

      return [];
    },
    selectAllItems () {
      this.createInitialSelectableItemsObject();

      Vue.nextTick(() => {
        Object.keys(this.selectedItems).forEach(key => {
          Vue.set(this.selectedItems, key, this.isAllItemsSelected);
        });

        if (this.selectionEvent) {
          this.$bus.$emit(this.selectionEvent, this.selectedItems, this.isAllItemsSelected);
        }
      });
    },
    createInitialSelectableItemsObject () {
      if (Object.keys(this.selectedItems).length !== this.listItems.length) {
        for (let i = 0; i < this.listItems.length; i++) {
          Vue.set(this.selectedItems, [this.listItems[i].id], this.isAllItemsSelected);
        }
      }
    },
    toggleSelect () {
      this.createInitialSelectableItemsObject();

      Vue.nextTick(() => {
        if (Object.values(this.selectedItems).every(val => (val === true))) {
          Vue.set(this, 'isAllItemsSelected', true);
        } else {
          Vue.set(this, 'isAllItemsSelected', false);
        }

        if (this.selectionEvent) {
          this.$bus.$emit(this.selectionEvent, this.selectedItems, this.isAllItemsSelected);
        }
      });
    },
    deselectAllItems () {
      Object.keys(this.selectedItems).forEach(key => {
        Vue.set(this.selectedItems, key, false);
      });
    },
    formatRoute(route, itemID) {
      let routePath = route;

      if (!routePath.length) {
        routePath = this.itemRoute;
      }

      routePath = routePath.split('/');
      let idIndex = routePath.indexOf(':id');

      routePath[idIndex] = itemID;

      return routePath.join('/');
    },
    getIsCellClickable (setting, settingsIndex, item) {
      if ((!this.itemAction && !this.itemRoute) || (this.itemsSelectable && settingsIndex === 0) || setting.route || setting.type === 'actions' || item.disabled) {
        return false
      }

      return true;
    },
    clickCellCalback (e, item) {
      e.preventDefault();

      if (this.itemRoute) {
        let route = this.formatRoute('', item.id);
        this.$router.push(route);

        return;
      }

      this.itemAction(item);
    },
    getBodyCellClassList (itemSettings, settingsIndex, item) {
      let classList = ['f-list-cell', 'align-middle', 'text-left'];

      if (itemSettings.type === 'f-badge') {
        classList.push('cell-badge');
      }

      if (itemSettings.type === 'actions') {
        classList.push('f-list-cell-actions');
      }

      if (itemSettings.type === 'actions' || itemSettings.type === 'f-message-counter') {
        classList.push('f-list-cell-mobile-inline');
      }

      if (this.getIsCellClickable(itemSettings, settingsIndex, item)) {
        classList.push('is-clickable');
      }

      if (itemSettings.additionalClass) {
        classList.push(itemSettings.additionalClass);
      }

      return classList.join(' ');
    }
  }
}
</script>
